import { MutationHookOptions, useMutation } from '@apollo/client';

import { SEND_INVITATION } from './mutations';

export const useResendLink = (options?: MutationHookOptions) => useMutation(SEND_INVITATION, options);
